import { IFormAccessJBP } from 'legacy/lut/classes/models/partner360/IFormAccessJBP'
import { appGetState } from 'legacy/lut/store'

import { IDataProviderFilter, IFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, Rest } from 'core/classes/http'

class PartnerManagementApi {
  public deleteProgram = async (programId: string, force: number) => {
    const url = proxy('/webservice/614/sp/v3/spJBPTryDeleteProgram/call')
    const payload: IObjectAny = {
      'p.ProgramId': programId,
      'p.Force': force,
    }
    const headers = await this.getHeaders()
    const response = await Rest.post({ url, payload, cancelObject: new HttpCancel(), headers })
    return (response && response['Rows']) || []
  }

  public checkPartnerContacts = async () => {
    const url = proxy('/webservice/621/sp/v3/spJBPCheckPartnerContacts/call')
    const payload: IObjectAny = {}
    const headers = await this.getHeaders()
    const response = await Rest.post({ url, payload, cancelObject: new HttpCancel(), headers })
    return (response && response['Rows']) || []
  }

  public copyDataFromPrevYear = async (partnerId: string, FYear: number) => {
    const url = proxy('/webservice/614/sp/v3/spJBPCopyDataFromPrevYear/call')
    const payload: IObjectAny = {
      'p.PartnerId': partnerId,
      'p.FYear': FYear,
    }
    const headers = await this.getHeaders()
    const response = await Rest.post({ url, payload, cancelObject: new HttpCancel(), headers })
    return (response && response['Rows']) || []
  }

  public fetchPartnerProgramsDetails = async (filter: IDataProviderFilter) => {
    const yearFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'FYear'
    ) as IFilter | undefined
    const partnerIdFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'PartnerId'
    ) as IFilter | undefined
    const programTypeFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'ProgramType'
    ) as IFilter | undefined
    const partnerTypeFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'PartnerType'
    ) as IFilter | undefined
    if (
      yearFilter &&
      yearFilter.value &&
      partnerIdFilter &&
      partnerIdFilter.value &&
      programTypeFilter &&
      programTypeFilter.value &&
      partnerTypeFilter &&
      partnerTypeFilter.value
    ) {
      const url = proxy('/webservice/614/sp/v3/spJBPProgramsForPartner/call')
      const payload = {
        'p.PartnerId': partnerIdFilter.value,
        'p.FYear': yearFilter.value,
        'p.ProgramType': programTypeFilter.value,
        'p.PartnerType': partnerTypeFilter.value,
      }

      const { app } = appGetState()
      const [accessToken] = await getTokens(app.ownerId)

      const headers = new HttpHeaders()
      if (accessToken) {
        headers.add('Authorization', `Bearer ${accessToken}`)
      }
      const response = await Rest.post({ url, payload, headers })
      const rows: IFormAccessJBP[] = (response && response['Rows']) || []
      return { Data: rows }
    }
    return { Data: [] }
  }

  public fetchPartnerPrograms = async (partnerId: string, FYear: number) => {
    const url = proxy(`/webservice/590/sp/v3/spJBPDaasTopPartnersSummary/call`)
    const payload = {
      'p.PartnerId': partnerId,
      'p.ProgramType': partnerId,
      'p.FYear': FYear,
    }

    const { app } = appGetState()
    const [accessToken] = await getTokens(app.ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const response = await Rest.post({ url, payload, headers })
    const rows: IFormAccessJBP[] = (response && response['Rows']) || []
    return { Data: rows }
  }

  private getHeaders = async () => {
    const { app } = appGetState()
    const [accessToken] = await getTokens(app.ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    return headers
  }
}

export const partnerManagementApi = new PartnerManagementApi()
